export default __webpack_public_path__ + "static/media/warning.72d15a95.svg";